export const extractQuoteData = (viewedId, sortedLoans) => {
  const selectedQuote = sortedLoans
  .flatMap((block) => block.quotes)
  .find((quote) => quote.id === viewedId);
  
  if (selectedQuote) {
    return selectedQuote;
  }
  return null;
};
